<main>
    <img src="/assets/images/logo_noovle_complete.svg" alt="Noovle a Tim enterprise brand" class="mw-100">
    <h1 class="mt-3 mb-5">Workspace Resource Provisioner</h1>
    <div id="googleBtn"></div>
</main>
<img src="/assets/images/logo.svg" alt="logo" class="logo">